import { Request } from '../../Servidor/Request';

export class CourtSituationRequest {
    private sgepsituacaoquadra: number;
    private nome: string;

	constructor(sgepsituacaoquadra: number, nome: string) {
		this.sgepsituacaoquadra = sgepsituacaoquadra;
		this.nome = nome;
	}


    /**
     * Getter sgepsituacaoquadra
     * @return {number}
     */
	public getSgepsituacaoquadra(): number {
		return this.sgepsituacaoquadra;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class CourtSituationStructRequest {
    private sgepsituacaoquadra: number;

	constructor(sgepsituacaoquadra: number) {
        this.sgepsituacaoquadra = sgepsituacaoquadra;
	}


    /**
     * Getter sgepsituacaoquadra
     * @return {number}
     */
	public getSgepsituacaoquadra(): number {
		return this.sgepsituacaoquadra;
	}

}

export class CourtSituationStructResponse {
    private sgepsituacaoquadra: number;
    private nome: string;

	constructor(sgepsituacaoquadra: number, nome: string) {
		this.sgepsituacaoquadra = sgepsituacaoquadra;
		this.nome = nome;
	}


    /**
     * Getter sgepsituacaoquadra
     * @return {number}
     */
	public getSgepsituacaoquadra(): number {
		return this.sgepsituacaoquadra;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class CourtSituationInteractor {
    public fetchSave(request: CourtSituationRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/situacao-quadra/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: CourtSituationStructRequest): PromiseLike<CourtSituationStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/situacao-quadra/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}